<template>
  <div class="company-info-card">
    <div class="card-header">
      <h5 class="header-title">
        <i class="icon-feather-briefcase"></i> {{ $t('profile.company_profile') }}
      </h5>
      <button class="settings-btn" :uk-tooltip="'title: ' + $t('general.update_information') + '; pos: left'" @click="$emit('closeModal')" type="button">
        <i class="icon-feather-settings"></i>
      </button>
    </div>
    <div class="divider"></div>
    <div v-if="user_detail" class="card-content">
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.company_name') }}</h5>
        <p class="info-value">{{ userItem && userItem.company ? userItem.company.name : '' }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('users.mission') }}</h5>
        <p class="info-value">{{ userItem && userItem.position ? userItem.position.name : '' }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.title') }}</h5>
        <p class="info-value">{{ userItem && userItem.title ? userItem.title.name : '' }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.gm_region') }}</h5>
        <p class="info-value">{{ userItem && userItem.region ? userItem.region.name : '' }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.unit') }}</h5>
        <p class="info-value">{{ userItem && userItem.department ? userItem.department.name : '' }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.branch') }}</h5>
        <p class="info-value">{{ userItem && userItem.branch ? userItem.branch.name : '' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyInformations',
  props: {
    userItem: {
      type: Object,
      default: () => ({})
    },
    user_detail: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.company-info-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  margin-top: 12px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
}

.header-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  display: flex;
  align-items: center;
}

.header-title i {
  font-size: 16px;
  margin-right: 6px;
}

.settings-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-btn i {
  font-size: 16px;
  color: #718096;
  transition: all 0.2s ease;
}

.settings-btn:hover i {
  color: #2c3e50;
  transform: rotate(90deg);
}

.divider {
  height: 1px;
  background-color: #e2e8f0;
  margin: 0;
}

.card-content {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 12px;
}

.info-item {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 4px 0;
  letter-spacing: 0.3px;
}

.info-value {
  font-size: 14px;
  color: #4a5568;
  margin: 0;
  line-height: 1.5;
  word-break: break-word;
}

@media (max-width: 768px) {
  .company-info-card {
    margin-top: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .header-title {
    font-size: 16px;
  }

  .card-content {
    padding: 12px;
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .info-label {
    font-size: 14px;
  }

  .info-value {
    font-size: 15px;
  }
}
</style>
